export default {
  // Toolbar
  toolbar: {
    searchPlaceholder: "Търсене на проба",
    refreshTooltip: "Обновяване на проби",
    filterTooltip: "Филтриране на проби",

    tabs: {
      samples: "Проби",
      visits: "Визити",
    },
  },

  // Sample list
  samples: {
    title: "Проби",
    noSamples: "В момента няма налични проби.",
    noSamplesSubtitle: "Пробите ще се появят тук, когато са готови за валидация.",
    refreshSamples: "Обновяване",
    noResults: 'Не са намерени проби за "{query}"',
    noSamplesMatchFilters: "Няма проби, отговарящи на зададените филтри",
    clearFilters: "Промяна на филтри",
    errorLoading: "Възникна грешка при зареждането на пробите.",
    error404: "API крайната точка не е намерена (404). Моля, проверете конфигурацията.",
    error500: "Сървърна грешка (500). Моля, опитайте отново по-късно.",
    errorAuth: "Грешка при удостоверяване. Моля, влезте отново.",
    errorNetwork: "Мрежова грешка. Моля, проверете интернет връзката си.",
    retry: "Повторен опит",

    actions: {
      highPriority: "Висок приоритет",
      more: "Още действия",
      edit: {
        title: "Редактиране на баркод",
        description: "Промяна на баркода на тази проба.",
      },
      info: {
        title: "Информация за проба",
        description: "Преглед на детайли за тази проба",
      },
      rejectAll: {
        title: "Отхвърляне на всички резултати",
        description: "Отхвърляне на всички чакащи резултати за тази проба.",
      },
    },
  },

  // Patient info
  patient: {
    dateOfBirth: "Дата на раждане",
    male: "М",
    female: "Ж",
  },

  // Visit info
  visit: {
    tooltips: {
      visitId: "ID на визита",
      visitDate: "Дата на визита",
      visitCategory: "Категория на визита",
      visitLocation: "Локация на визита",
      requester: "Заявяващо отделение",
      notes: "Бележка за визита",
      doctor: "Лекар",
    },
  },

  // Results
  results: {
    noDataAvailable: "Няма налични данни",
    noDataAvailableSubtitle: "Тази проба няма резултати или информация за посещение.",
    edited: "редактиран",
    viewEditHistory: "Преглед на историята на редакциите",
    pending: {
      title: "Чакащи резултати",
      rejectAll: "Отхвърляне на всички",
      acceptAll: "Приемане на всички",
      reject: "Отхвърляне",
      accept: "Приемане",
      addAndAccept: "Добавяне и приемане",
      moreActions: "Още действия",
      expand: "Разгъване на всички",
      collapse: "Свиване на всички",
      viewHistory: "История",
      viewHistoryDescription: "Преглед на история на пациента за този тест.",
      flagsDescription: "Преглед на флагове, свързани с този резултат.",
      rejectDescription: "Отхвърляне на резултат",
      editDescription: "Редактиране на резултат",

      acceptSuccess: "Резултатът е приет успешно",
      acceptError: "Неуспешно приемане на резултата",
      acceptAllSuccess: "Всички резултати са приети",
      acceptAllError: "Неуспешно приемане на всички резултати",
      rejectSuccess: "Резултатът е отхвърлен",
      rejectError: "Неуспешно отхвърляне на резултата",
      rejectAllSuccess: "Всички резултати са отхвърлени",
      rejectAllError: "Неуспешно отхвърляне на всички резултати",
      resultTimeTooltip: "Време на изработване на резултат от апарат",

      errors: {
        networkError: "Грешка в мрежата. Моля, проверете връзката си и опитайте отново.",
        serverError: "Възникна сървърна грешка. Моля, опитайте отново по-късно.",
        loadingFailed: "Неуспешно зареждане на резултатите. Моля, опитайте отново.",
        pleaseTryAgain: "Моля, опитайте отново.",
        nonDeterministicProfile:
          "Не може да се определи еднозначен профил за този незадължителен тест.",
      },
    },
    current: {
      title: "Текущи резултати",
      resultTimeTooltip: "Време на валидиране и публикуване в ЛИС",
    },
    editedIndicator: "Този резултат е редактиран ръчно",
    editTooltip: {
      previousValue: "Предишна стойност",
      editedBy: "Редактирано от",
      editedAt: "Редактирано на",
    },
    refRange: "Реф. граници",
    viewHistory: "Преглед на история на пациента",
    loadingData: "Зареждане на данни...",
  },

  flags: {
    descriptions: {
      0: "Неизвестно",
      1: "Значително под референтния диапазон",
      2: "Под референтния диапазон",
      3: "Леко под нормата",
      4: "В нормални граници",
      5: "Леко над нормата",
      6: "Над референтния диапазон",
      7: "Критично високо ниво",
    },
  },

  // Alerts
  alerts: {
    visitMissing: {
      title: "Липсва информация за визита",
      message: "Няма информация за визита, свързана с тази проба.",
    },
    noResults: {
      title: "Не са намерени резултати",
      message: "Няма резултати, свързани с тази проба.",
    },
    flaggingMissing: {
      title: "Липсва информация за флагиране",
      message: "Няма информация за флагиране, свързана с тази проба.",
    },
  },

  // Dialogs
  dialogs: {
    // Edit Sample Dialog
    editSample: {
      title: "Редактиране на баркод на проба",
      description: "Редактирате баркода за проба: <strong>{barcode}</strong>",
      newBarcodeLabel: "Нов баркод",
      hint: "Баркодът може да съдържа само букви, цифри, тире (-) и долна черта (_)",
      errors: {
        required: "Баркодът е задължителен",
        barcodeExists: "Проба с този баркод вече съществува",
        containsQuotes: "Баркодът не може да съдържа кавички (' или \")",
        containsBackslash: "Баркодът не може да съдържа обратна наклонена черта (\\)",
        containsSpecialChars: "Баркодът не може да съдържа специални знаци (нов ред, табулация)",
        invalidCharacters: "Баркодът може да съдържа само букви, цифри, тире (-) и долна черта (_)",
        networkError: "Грешка в мрежата - моля опитайте отново",
      },
      success: "Баркодът на пробата е актуализиран успешно",
      error: "Неуспешна актуализация на баркода на пробата",
    },

    // Edit Result Dialog
    editResult: {
      title: "Редактиране на резултат",
      fields: {
        testName: "Име на теста",
        originalResult: "Оригинален резултат",
        newResult: "Нов резултат",
        reason: "Причина за редакция (по избор)",
        reasonPlaceholder: "напр., Коригирана инструментална грешка, Ръчно преизчисляване",
        units: "Единици",
        range: "Референтен диапазон",
        resultTime: "Дата / Час",
      },
      preview: {
        title: "Парсирана стойност",
        parsed: "Ще се запази като",
      },
      changePreview: "Промяна",
      validation: {
        required: "Това поле е задължително",
        invalidNumeric: "Моля, въведете валидна числова стойност",
        belowRange: "Под диапазона: {range}",
        aboveRange: "Над диапазона: {range}",
        withinRange: "В диапазона: {range}",
      },
      success: "Резултатът е актуализиран успешно",
      error: "Неуспешна актуализация на резултата",
    },

    // Filter Samples Dialog
    filterSamples: {
      title: "Филтриране на проби",
      priority: {
        label: "Приоритет: {status}",
        stat: "спешни",
        all: "всички",
      },
      fields: {
        locations: "Локации",
        instruments: "Апарати",
        sampleTypes: "Типове проби",
        visitTypes: "Типове визити",
        requesters: "Заявители",
        doctors: "Лекари",
      },
    },

    // Patient History Dialog
    patientHistory: {
      title: "История на пациента - {testName}",
      subtitle: "{count} исторически резултати",
      loading: "Зареждане на история на пациента...",
      noHistory: "Не са намерени исторически резултати за този тест",
      range: "Диапазон: {range}",

      // Error states
      errors: {
        serverTitle: "Нещо се обърка",
        serverSubtitle: "Неуспешно зареждане на историята. Моля, опитайте отново.",
        networkTitle: "Загубена връзка",
        networkSubtitle: "Не може да се свърже със сървъра. Проверете връзката си.",
        timeoutTitle: "Времето за заявка изтече",
        timeoutSubtitle: "Сървърът отговаря твърде бавно. Моля, опитайте отново.",
        authTitle: "Сесията изтече",
        authSubtitle: "Моля, влезте отново, за да продължите.",
        unknownTitle: "Неочаквана грешка",
        unknownSubtitle: "Нещо се обърка. Моля, опитайте по-късно.",
        validationTitle: "Невалидна заявка",
        validationSubtitle: "Заявката не може да бъде обработена.",
        retry: "Повторен опит",
        login: "Вход",
      },

      tabs: {
        data: "Данни",
        chart: "Графика",
      },

      table: {
        visitId: "ID на визита",
        resultTime: "Дата / Час",
        result: "Резултат",
        currentVisit: "Текуща визита",
      },

      chart: {
        results: "Резултати",
        normalRange: "Реф. граници",
        current: "Текущ",
        date: "Дата",
        value: "Единица",
        tooltipResult: "Резултат",
        tooltipUnits: "Единица",
        tooltipRefRange: "Реф. граници",
        tooltipCurrentVisit: "Текуща визита",
        noChartData: "Няма числови данни за показване в графиката",
      },
    },

    // Reject All Dialog
    rejectAll: {
      title: "Потвърждаване на отхвърляне на всички",
      message:
        "На път сте да отхвърлите <strong>всички резултати</strong> за проба: <strong>{barcode}</strong>",
      warning: "Всички чакащи резултати, свързани с тази проба, ще бъдат трайно изтрити.",
      confirm: "Отхвърляне на всички резултати",
    },

    flags: {
      title: "Флагове",
      headers: {
        level: "Ниво",
        source: "Източник",
        code: "Код",
        description: "Описание",
      },
      levels: {
        0: "Неизвестно",
        1: "Информация",
        2: "Предупреждение",
        3: "Грешка",
        4: "Критично",
      },
    },
  },

  signalr: {
    connected: "Активни актуализации в реално време",
    disconnected: "Актуализациите в реално време са изключени",
    reconnecting: "Опит за повторно свързване към актуализации в реално време...",
    barcodeChanged: "Баркод променен: {old} → {new}",
    connectionFailed:
      "Неуспешна връзка с SignalR след {attempts} опита. Страницата ще работи, но без актуализации в реално време.",
    resultsAdded: "{count} нови резултата за {barcode}",
    resultsDeleted: "{count} изтрит резулта за {barcode}",
    resultsModified: "{count} променени резултата за {barcode}",
    sampleAdded: "Нова проба с баркод: {barcode} е добавена",
    sampleRemoved: "Проба {barcode} беше премахната",
  },
};
